var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlockMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 96,
    viewBox: "0 0 102 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3365_794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2803 50.6035L1.08203 59.9753V82.3301L19.4667 94.4568",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.862 83.8652L19.6777 94.7248",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2715 50.7305L38.6514 59.9768V74.9968",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.08203 59.9629C1.45829 60.3391 19.7132 72.1501 19.7132 72.1501",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6499 59.9629C38.2736 60.3391 19.3008 72.548 19.3008 72.548",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4922 71.8086V94.0899",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3789 23.4368V12.9146L51.5377 1.08203",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5377 26.2517L32.3789 12.9141",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1621 26.252V48.0445",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3252 12.9141L51.1621 26.2517",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7285 8.7832L38.9531 17.4241V23.9978",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7022 23.4368V12.9146L51.5391 1.08203",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3516 8.7832L64.127 17.4241V23.9978",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0039 35.6445L51.1194 48.061",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0879 35.082L51.3526 40.155",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5726 35.6445L50.8809 48.0134",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2494 60.2002L19.0332 37.4043",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9473 37.6337L37.3276 27.9375",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4891 35.082L51.2148 39.8177",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3223 74.9961L50.2629 88.178",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7239 50.6035L100.918 59.9753V82.3301L82.5332 94.4568",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1387 83.8652L82.323 94.7248",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7295 50.7305L63.3496 59.9768V74.9968",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.918 59.9629C100.542 60.3391 82.2871 72.1501 82.2871 72.1501",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3496 59.9629C63.7259 60.3391 82.6987 72.548 82.6987 72.548",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5078 71.8086V94.0899",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.75 60.2002L82.9662 37.4043",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0522 37.6337L64.6719 27.9375",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6832 74.9961L51.7383 88.178",
    stroke: "white",
    strokeWidth: 2.16239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3365_794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 95.8069,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockMain);
export default __webpack_public_path__ + "static/media/block-main.5831069e.svg";
export { ForwardRef as ReactComponent };